import { Dayjs } from 'dayjs';
import dayjs from './dayjsSetup';

const isStartOfMonth = (date: Dayjs): boolean => {
  return dayjs(date).isSame(dayjs(date).startOf('month'), 'day');
};

export default isStartOfMonth;
